import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const NAV_LINKS = {
  admin: [
    { label: "Home", to: "/" },
    // { label: "Admin Home", to: "/dashboard" },
    // { label: "Doctor Dashboard", to: "/doctor-dashboard" },
    // { label: "Patient List", to: "/patient-list" },
    // { label: "Invoices", to: "/invoices" },
    // { label: "Profile", to: "/doctor-profile" },
    // { label: "Pharmacy", to: "/pharmacy" },
    { label: "Logout", to: "/login", logout: true }
  ],
  doctor: [
    { label: "Doctor Dashboard", to: "/doctor-dashboard" },
    { label: "Patient List", to: "/patient-list" },
    { label: "Invoices", to: "/invoices" },
    { label: "Profile", to: "/doctor-profile" },
    { label: "Pharmacy", to: "/pharmacy" },
    { label: "Logout", to: "/login", logout: true }
  ],
  patient: [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/aboutus" },
    { label: "Contact Us", to: "/contact" },
    { label: "Logout", to: "/login", logout: true }
  ]
};

export default function DashboardNavbar() {
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const role = user?.role || "patient";
  const links = NAV_LINKS[role] || NAV_LINKS.patient;

  const handleLogout = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    logout();
    window.location.href = "/login";
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/dashboard">Dashboard</Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen(!open)}
          aria-controls="dashboardNavbar"
          aria-expanded={open}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse${open ? " show" : ""}`} id="dashboardNavbar">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {links.map(link => (
              <li className="nav-item" key={link.label}>
                {link.logout ? (
                  <a className="nav-link" href="/login" onClick={handleLogout}>Logout</a>
                ) : (
                  <Link className="nav-link" to={link.to}>{link.label}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
